module.exports = __webpack_public_path__ + "media/images/banners/1-cb6cde26bf6634be1a7c26ac5b80a432.jpg";